import { Controller } from "@hotwired/stimulus";

/**
 * フラッシュメッセージの表示・自動非表示を管理するStimulusコントローラー
 *
 * 使用場所:
 * - 全画面共通（成功・エラーメッセージなど）
 * - 注文完了後の確認メッセージ
 * - バリデーションエラーメッセージ
 *
 * 主な機能:
 * - フラッシュメッセージの自動非表示（指定時間後）
 * - フェードアウトアニメーション
 * - 手動での閉じる機能
 *
 * 必要なターゲット要素:
 * - alert: メッセージ表示エリア
 *
 * 設定値:
 * - autoDismiss: 自動非表示までの時間（ミリ秒）
 */
export default class extends Controller {
  static targets = ["alert"];
  static values = { autoDismiss: Number };

  connect() {
    if (this.autoDismissValue > 0) {
      setTimeout(() => {
        this.dismiss();
      }, this.autoDismissValue);
    }
  }

  dismiss() {
    this.alertTarget.style.opacity = "0";

    setTimeout(() => {
      this.element.remove();
    }, 500); // transition-opacity duration-500 と合わせる
  }
}
